import { Endpoint } from '@/constants';
import { useShipping } from '@/contexts/shippingContext';
import { useSendOrder } from '@/hooks/useSendOrder';

export const usePayPal = () => {
  const { isPending, sendOrder } = useSendOrder(Endpoint.SendPayPalOrder);
  const { orderPayload } = useShipping();

  const createOrder = () => {
    console.info('usePayPal: createOrder called');
    sendOrder({
      ...orderPayload,
    });
  };

  return { createPayPalOrder: createOrder, isPending };
};
